export const parseFeatureFlags = user => {
  if (user?.featureFlags) {
    return JSON.parse(user.featureFlags.flags)
  }

  return undefined
}

export const getFeatureFlagsFromState = state =>
  JSON.parse(state.profileReducer.doctor?.user?.featureFlags?.flags || '{}')
